import { render, staticRenderFns } from "./MainFrame.vue?vue&type=template&id=3fbbe5b8&scoped=true"
import script from "./MainFrame.vue?vue&type=script&lang=js"
export * from "./MainFrame.vue?vue&type=script&lang=js"
import style0 from "./MainFrame.vue?vue&type=style&index=0&id=3fbbe5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbbe5b8",
  null
  
)

export default component.exports